import { defineComponent as _defineComponent } from 'vue'
import {
  BendTrendSeasonalProductivitySummaryData,
  BendTrendSeasonalYearProductivityData,
} from '@/models/Charts/chartsData';
import SummaryComparisonKpiWidget from '../common/kpiWidget/SummaryComparisonKpiWidget.vue';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import { computed } from 'vue';
import { isNil, maxBy, minBy } from '@/utils/misc';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { formatPercentage } from '@/utils/number';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendTrendSeasonalProductivitySummaryKpiWidget',
  props: {
    data: null,
    generator: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: BendTrendSeasonalProductivitySummaryData | null;
  generator: ChartGenerator<BendTrendSeasonalProductivitySummaryData>;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  isFetchingForTheFirstTime: boolean;
};



const { t } = useI18n();

const mainFact = computed<number>(() => {
  if (isNil(props.data)) {
    return 0;
  }

  return props.data.totalProductivityPercentage;
});

const bestYearData = computed<
  BendTrendSeasonalYearProductivityData | undefined
>(() =>
  maxBy(props.data?.productivityPerYear, (item) => item.productivityPercentage),
);

const worstYearData = computed<
  BendTrendSeasonalYearProductivityData | undefined
>(() =>
  minBy(props.data?.productivityPerYear, (item) => item.productivityPercentage),
);

const worstYear = computed<number>(() => worstYearData.value?.year ?? 0);

const bestYear = computed<number>(() => bestYearData.value?.year ?? 0);

const bestYearProductivity = computed<number>(
  () => bestYearData.value?.productivityPercentage ?? 0,
);

const worstYearProductivity = computed<number>(
  () => worstYearData.value?.productivityPercentage ?? 0,
);

return { __sfc: true,props, t, mainFact, bestYearData, worstYearData, worstYear, bestYear, bestYearProductivity, worstYearProductivity, SummaryComparisonKpiWidget, formatPercentage }
}

})